<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Accounts',
        route: { name: 'sales-accounts' }
      },
      actions: this.$parent.actions
    }
  }
}
</script>
